<template>
  <Title>{{ pageTitle }}</Title>
  <SmartLinkItem v-if="data" :item-id="data?.system?.id">
    <component :is="activeComponent" v-if="activeComponent" />
  </SmartLinkItem>
  <ScriptTags />

</template>

<script lang="ts" setup>

import { useCDNHeaders } from '#nuxt-multi-cache/composables'
import {
  HomePage,
  InteriorPage,
  ModulePage,
  PartnerPage,
  PlatformPage,
} from '#components'
import { contentTypes } from '../models'


let pageType = ''
const pageTitle = ref('')
const data = ref()
const pageStore = usePageStore()
const config = useRuntimeConfig()
const route = useRoute()
const anchorNavBar = useAnchorNavBar();

anchorNavBar.reset();

const page = await pageStore.getPage(route.path, route.query?.itemid as string)
if (page) {

  await pageStore.fetchData(page.itemid)
  if (pageStore.page) {
    data.value = pageStore.page
    pageType = page.type
    pageTitle.value = page.title
  }
} 

if (!data.value) {
  throw createError({
    statusCode: 404,
    statusMessage: 'Page Not Found'
  })
}

const activeComponent = resolveComponent(pageType)

if (config.enableCdn) {
  useCDNHeaders((helper) => {
    helper
      .public()
      .setNumeric('maxAge', Number(config.cacheMaxAge))
      .setNumeric('staleIfError', 43200)
  })
}

function resolveComponent(type: string): Component | null {
  switch (type) {
    case contentTypes.homepage.codename:
      return HomePage
    case contentTypes.interior_page.codename:
      return InteriorPage
    case contentTypes.platform_page.codename:
      return PlatformPage
    case contentTypes.partner_item.codename:
      return PartnerPage
    case contentTypes.module_item.codename:
      return ModulePage
    default:
      return null
  }
}


</script>
